<template>
  <div :class="className" class="notification-banner">
    <small v-for="(item, index) in messageList" :key="`message-${index}`">{{
      item
    }}</small>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: [Array, String],
    required: true,
  },

  isDanger: {
    type: Boolean,
    default: false,
  },

  isWarning: {
    type: Boolean,
    default: false,
  },

  isSuccess: {
    type: Boolean,
    default: false,
  },
})

const className = computed<string | null>(() => {
  if (props.isDanger) {
    return 'is-danger'
  }

  if (props.isWarning) {
    return 'is-warning'
  }

  if (props.isSuccess) {
    return 'is-success'
  }

  return null
})

const messageList = computed<Array<string>>(() =>
  Array.isArray(props.message) ? props.message : [props.message],
)
</script>

<style lang="scss" scoped>
@use 'sass:color';
@import 'src/assets/scss/globals';

.notification-banner {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;
  padding: 0.75em 1em;
  border: $border-width solid $color-accent;
  border-radius: 0.25em;
  border-left-width: (5 * $border-width);
  background-color: color.adjust($color-accent, $lightness: 58%);
  color: $color-accent;

  &.is-success {
    border-color: $color-success;
    background-color: color.adjust($color-success, $lightness: 55%);
    color: $color-success;
  }

  &.is-warning {
    border-color: $color-warning;
    background-color: color.adjust($color-warning, $lightness: 45%);
    color: color.adjust($color-warning, $lightness: -15%);
  }

  &.is-danger {
    border-color: $color-danger;
    background-color: color.adjust($color-danger, $lightness: 50%);
    color: $color-danger;
  }
}
</style>
